import { accountServices } from '../../services/trading-services';
import { I_TRADE_ACTION as types } from '../../constants/i-trade';
import { APP_SETTING_ACTION as appTypes } from '../../constants/app';
import { SERVICES_RESP as servicesResp } from '../../configurations';
import { PARAMS as paramsRq } from '../../constants/params';
import { Converter, Filter } from '../../helpers/functions';
import { getSafeStorage , saveSafeStorage} from '@/helpers/global';
import { STORAGE_KEY } from '../../constants/storage.key';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { PARAMS } from '@/constants/params';

export const accountActions = {
  getAvailableQuantityAction,
  getAAStockAction,
  getAccountBankBalanceAction,
  getStatementListAction,
  getStatementContentAction,
  EnquiryBuyingPowerAction,
  queryAccountDetailsAction,
  createTradingAccAction,
}

export const getAccountBalanceAction = (params, callback) => {
  return dispatch => {
    if (!params[paramsRq.CLIENT_ID]) return
    return accountServices.getAccountBalance(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices);
      } else {
        // const toast = {
        //   type: 'error',
        //   autoClose: true,
        //   errorCode: returnedServices.status,
        //   isOpen: true
        // }
        // dispatch({
        //   type: appTypes.SHOW_TOAST,
        //   toast: toast
        // })
      }
    })
  }
}

export const getPortfolioAction = (params, callback) => {
  return dispatch => {
    if (!params[paramsRq.CLIENT_ID]) return
    return accountServices.getPortfolioService(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result);
        if (!params.marketID) {
          dispatch({
            type: types.GET_POSITION_DATA,
            portfolios: returnedServices.result
          })
        }
      } else {
        // const toast = {
        //   type: 'error',
        //   autoClose: true,
        //   errorCode: returnedServices.status,
        //   isOpen: true
        // }
        // dispatch({
        //   type: appTypes.SHOW_TOAST,
        //   toast: toast
        // })
      }
    })
  }
}

export const getTransactionHistoryAction = (params, callback) => {
  return dispatch => {
    if (!params[paramsRq.CLIENT_ID]) return
    return accountServices.getTransactionHistoryService(params, returnedServices => {
      callback(returnedServices);
    })
  }
}

export const getTradingAccount = (params, callback) => {
  return dispatch => {
    return accountServices.getTradingAccount(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result);
        if (returnedServices.result.errorCode === servicesResp.SUCCESS_CODE) {
          let tradeAccount = Filter.filterDefaultTradingAccount(returnedServices.result.itemlist)
          let ctradeAccount = getSafeStorage(STORAGE_KEY.T_ACCOUNT)?Filter.filterCurrentSubAccount(returnedServices.result.itemlist,getSafeStorage(STORAGE_KEY.T_ACCOUNT)):''
          if (tradeAccount !== undefined) {
            let clientID = Filter.filterDefaultTradingAccount(Converter.mapTradeAccountToOption(returnedServices.result.itemlist)).clientID;
            dispatch({
              type: types.GET_TRADING_ACCOUNT,
              tradingAccounts: ctradeAccount?ctradeAccount:returnedServices.result.itemlist,
              clientID: clientID
            });
            let data = {
              tradingAccounts : ctradeAccount?ctradeAccount:returnedServices.result.itemlist,
              clientID : clientID,
              tradeAccount : tradeAccount
            }
            saveSafeStorage(STORAGE_KEY.TRADE_ACCOUNT, JSON.stringify(data));
            if (iTradeEnv?.actions?.trading?.getCashAccount) {
              dispatch(getCashAccount())
            }
          } else {
            if (returnedServices.result.itemlist.length > 0) {
              const p = {
                [paramsRq.TRADING_ACCOUNT]: returnedServices.result.itemlist[0],
                [paramsRq.TRADING_ACCOUNT_ID]: returnedServices.result.itemlist[0].clientID,
                [paramsRq.SERVICE]: returnedServices.result.itemlist[0].service,
                [paramsRq.LOGIN_ID]: params[paramsRq.LOGIN_ID]
              }
              returnedServices.result.itemlist[0].isDefault = true;
              dispatch({
                type: types.GET_TRADING_ACCOUNT,
                tradingAccounts: returnedServices.result.itemlist,
                clientID: returnedServices.result.itemlist[0].clientID
              });
              dispatch(setDefaultTradingAccountAction(p, res => {
                // TO DO
              }));
            }
          }
        }
      } else {
        // const toast = {
        //   type: 'error',
        //   autoClose: true,
        //   errorCode: returnedServices.status,
        //   isOpen: true
        // }
        // dispatch({
        //   type: appTypes.SHOW_TOAST,
        //   toast: toast
        // })
      }
    })
  }
}

export const switchTradingAccount = (params, callback) => {
  return dispatch => {
    return accountServices.switchTradingAccount(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result);
        if (returnedServices.result.errorCode === servicesResp.SUCCESS_CODE) {
          dispatch({
            type: types.SWITCH_TRADING_ACCOUNT,
            currentTradingAccount: params[paramsRq.TRADING_ACCOUNT],
            clientID: params[paramsRq.TRADING_ACCOUNT].clientID
          });
        }
      } else {
        // const toast = {
        //   type: 'error',
        //   autoClose: true,
        //   errorCode: returnedServices.status,
        //   isOpen: true
        // }
        // dispatch({
        //   type: appTypes.SHOW_TOAST,
        //   toast: toast
        // })
      }
    })
  }
}

export const setDefaultTradingAccountAction = (params, callback) => {
  return dispatch => {
    return accountServices.setDefaultTradingAccount(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result);
        if (returnedServices.result.errorCode === servicesResp.SUCCESS_CODE) {
          dispatch({
            type: types.SET_CURRENT_TRADING_ACCOUNT,
            currentTradingAccount: params[paramsRq.TRADING_ACCOUNT],
            clientID: params[paramsRq.TRADING_ACCOUNT].clientID
          });
        }
      } else {
        // const toast = {
        //   type: 'error',
        //   autoClose: true,
        //   errorCode: returnedServices.status,
        //   isOpen: true
        // }
        // dispatch({
        //   type: appTypes.SHOW_TOAST,
        //   toast: toast
        // })
      }
    })
  }
}

export const getAssetAllocation = (params, callback) => {
  return dispatch => {
    return accountServices.getAssetAllocation(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result);
      } else {
        // const toast = {
        //   type: 'error',
        //   autoClose: true,
        //   errorCode: returnedServices.status,
        //   isOpen: true
        // }
        // dispatch({
        //   type: appTypes.SHOW_TOAST,
        //   toast: toast
        // })
      }
    })
  }
}

function getAvailableQuantityAction(params, callback) {
  return () => {
    return accountServices.getAvailableQuantityService(params, res => {
      callback(res);
    })
  }
}

function getAAStockAction(params, callback) {
  return () => {
    return accountServices.getAAStockService(params, res => {
      callback(res);
    })
  }
}

function getAccountBankBalanceAction(params, callback) {
  return () => {
    return accountServices.getAccountBankBalanceService(params, res => {
      callback(res);
    })
  }
}

function getStatementListAction(params, callback) {
  return () => {
    return accountServices.getStatementListService(params, res => {
      callback(res);
    })
  }
}

function getStatementContentAction(params, callback) {
  return () => {
    return accountServices.getStatementContentService(params, res => {
      callback(res);
    })
  }
}

export const  getCashAccount = () => {
  return (dispatch, getState) =>{
  const currentTradingAccount = getState().trade.currentTradingAccount
  const language = getState().app.language
  const { clientID, tradingAccSeq } = currentTradingAccount
  const params = {
    [PARAMS.CLIENT_ID]: clientID,
    [PARAMS.TRADING_ACCOUNT_ID]: clientID,
    [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
    [PARAMS.LANGUAGE]: language.lang
  }
  dispatch({
    type:types.GET_ACCOUNT_BANLANCE,
    assetloading:true,
  })
  if (clientID && JSON.stringify(currentTradingAccount) !=='{}') {
    accountServices.getAssetAllocation(params, res => {
      if (res.status === servicesResp.STATUS_OK) {
        dispatch({
          type:types.GET_ACCOUNT_BANLANCE,
          assetloading:false,
          cashAccountData :Converter.mapAssetAllocation(res.result)
        })
      }else{
        dispatch({
          type:types.GET_ACCOUNT_BANLANCE,
          assetloading:false,
          cashAccountData : ''
        })
      }
    })
  }
  }
}

function EnquiryBuyingPowerAction(params, callback) {
  return () => {
    return accountServices.EnquiryBuyingPowerService(params, res => {
      callback(res);
    })
  }
}

function queryAccountDetailsAction(params, callback) {
  return () => {
    return accountServices.queryAccountDetailsService(params, res => {
      callback(res);
    })
  }
}

function createTradingAccAction(params, callback) {
  return () => {
    return accountServices.createTradingAccService(params, res => {
      callback(res); 
    })
  }
}